
const Skeleton = ({ className}) => (
    <div className={`animate-pulse bg-gray-200 dark:bg-zinc-700 rounded ${className}`}></div>
);

export const TableSkeleton = () => {
    const rows = Array(10).fill(0);
    return (
        <div className="w-full overflow-x-scroll bg-white dark:bg-zinc-800 rounded-lg shadow-sm">
            <div className="flex items-center gap-4 border-b border-gray-200 dark:border-zinc-700 bg-gray-50 dark:bg-zinc-800/50 p-4">
                {[...Array(6)].map((_, i) => (
                    <Skeleton key={i} className="h-4 w-1/6" />
                ))}
            </div>

            <div className="divide-y divide-gray-100 dark:divide-zinc-700">
                {rows.map((_, index) => (
                <div key={index} className="flex items-center justify-around p-4">
                    <Skeleton className="h-5 w-12" />
                    <Skeleton className="h-6 w-24 rounded-full" />
                    <Skeleton className="hidden sm:block sm:h-5 sm:w-16" />
                    <Skeleton className="h-5 w-1/3" />
                    <Skeleton className="hidden xl:block xl:h-5 xl:w-20" />
                    <Skeleton className="hidden xl:block xl:h-5 xl:w-16" />
                    <Skeleton className="hidden sm:block sm:h-8 sm:w-8 rounded-full" />
                    <Skeleton className="h-5 w-24" />
                </div>
                ))}
            </div>
        </div>
    );
};

export const CardSkeleton = () => {
    const cards = Array(6).fill(0);
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4">
            {cards.map((_, index) => (
                <div key={index} className="bg-white dark:bg-zinc-800 rounded-2xl p-6 border border-gray-100 dark:border-zinc-700 shadow-sm">
                    <div className="flex gap-2 mb-4">
                        <Skeleton className="h-6 w-20 rounded-md" />
                        <Skeleton className="h-6 w-24 rounded-md" />
                    </div>

                    <Skeleton className="h-7 w-3/4 mb-4" />

                    <div className="flex items-center gap-5 mt-auto pt-2">
                        <div className="flex items-center gap-2">
                            <Skeleton className="h-4 w-4 rounded-full" /> {/* アイコン */}
                            <Skeleton className="h-4 w-24" />
                        </div>
                        <div className="flex items-center gap-2">
                            <Skeleton className="h-2 w-2 rounded-full" /> {/* 点 */}
                            <Skeleton className="h-4 w-16" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};